import { useEffect, useState } from "react";
import { useRoute, useLocation } from "wouter";
import { Gift, ArrowRight } from "lucide-react";

/**
 * /r/:code — influencer share-link landing. Saves the code so it pre-fills the
 * checkout discount field (see OrderStoreDetail), then invites the visitor in.
 * The normal first-order eligibility checks still apply at checkout.
 */
export default function ReferralLanding() {
  const [, params] = useRoute("/r/:code");
  const [, setLocation] = useLocation();
  const [code, setCode] = useState<string>("");
  const [percent, setPercent] = useState(20);

  useEffect(() => {
    const c = (params?.code ?? "").replace(/[^A-Za-z0-9_-]/g, "").toUpperCase();
    if (c) { setCode(c); try { localStorage.setItem("influencer_ref_code", c); } catch { /* ignore */ } }
    fetch("/api/influencer/terms").then((r) => r.ok ? r.json() : null).then((t) => { if (t?.discountPercent) setPercent(t.discountPercent); }).catch(() => {});
  }, [params?.code]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-gradient-to-br from-[#1e3a5f] to-[#2a4a6f] text-white rounded-2xl p-8 shadow-lg text-center">
        <Gift size={40} className="mx-auto text-[#f0a500]" />
        <h1 className="text-2xl font-bold mt-4">You’ve got {percent}% off your first order</h1>
        <p className="text-white/85 mt-2">Use code <span className="font-black tracking-wider bg-white/15 px-2 py-0.5 rounded">{code}</span> at checkout at participating Ayrshire Hub stores. We’ve saved it for you.</p>
        <p className="text-white/60 text-sm mt-2">Valid on your account’s first order across Ayrshire Hub.</p>
        <button onClick={() => setLocation("/order")} className="mt-6 w-full bg-[#f0a500] text-[#1e3a5f] font-bold py-3 rounded-xl flex items-center justify-center gap-2">Start ordering <ArrowRight size={18} /></button>
        <button onClick={() => setLocation("/signup")} className="mt-2 w-full bg-white/10 text-white font-semibold py-3 rounded-xl">Create an account</button>
      </div>
    </div>
  );
}
